import { call } from '../core'

export interface INavigateParams {
  scheme: string
  isClose?: boolean // webView를 닫고 이동해야 할 경우 true
}

export function navigateTo(params: INavigateParams) {
  call('finNavigateTo', params)
}
